import React from 'react';
import { label } from '../../../base-styles/forms.module.css';

const FieldLabel = ({ id, required, title }) => {
  return (
    title && (
      <label htmlFor={id} className={label}>
        {title}
        {required && '*'}
      </label>
    )
  );
};

export default FieldLabel;
